// extracted by mini-css-extract-plugin
export default {"root":"FormInput_root__b+Vl3","labelText":"FormInput_labelText__pJZ7h"};